import React, { PropTypes } from 'react';

const propTypes = {
  extraClasses: PropTypes.string,
  icon: PropTypes.string,
  children: PropTypes.node.isRequired,
};

const Label = (props) => {
  const className = `ui ${props.extraClasses} label`;
  const icon = props.icon && <i className={`ui ${props.icon} icon`} />;
  return <div className={className}>{icon}{props.children}</div>;
};

Label.propTypes = propTypes;

export default Label;



/** WEBPACK FOOTER **
 ** ./src/components/layout/sui/label/Label.js
 **/